import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { DataService } from '../../../services/data/data.service';
import { TranslateService } from '@ngx-translate/core';
import { ExcelService } from '../../../services/excel/excel.service';
import { CookieService } from 'ngx-cookie-service';
import { EvaluacionEntity } from '../../funciones/AlertaTemprana';
import { messages } from '../../funciones/mensajes';
import { HttpHeaders } from '@angular/common/http';
import { calculos, CommonVariables, formatear, FuncionesMes } from '../../funciones/funcionesGenerales';
import { indCoberturas } from '../idsTablas';
import { cobertura, cuenta, cuentasP, variable, variableTemp, varP, varTP } from '../../riesgo-liquidez/tablaslds';
import { IMG } from '../../../services/imagen/png';
import moment from 'moment';
import { FiltersM } from '../../../components/models';
import { IndicadoresCoberturaService } from '../../../services/financiero/indicadores-cobertura/indicadores-cobertura.service';
import { GraficadorComponent } from '../../../components/graficador/graficador.component';
import { ServiciosRiegosService } from '../../../services/riesgo-liquidez/servicios-riegos.service';
import { companiesFinanciero, companiesRiesgoLiquidez } from '../../../shared/catalogos';

@Component({
  selector: 'app-indicadores-cobertura',
  templateUrl: './indicadores-cobertura.component.html',
  styleUrl: './indicadores-cobertura.component.css'
})
export class IndicadoresCoberturaComponent implements OnInit {
  public Filters = FiltersM;
  @ViewChildren(GraficadorComponent)grafCmp!:QueryList<GraficadorComponent>;
  /*Datos graficas formateados para el componente graficador*/
  public dataGraf1FormattedForGraficador = [];
  public labelsGraf1 = [];
  public tipoGraf1Actual = 'radar';
  public dataGraf2FormattedForGraficador = [];
  public labelsGraf2 = [];
  public tipoGraf2Actual = 'line';
  public showEti1 = false;
  public showEti2 = false;
  /* Graficas apex */
  public verGraf = false;
  public verGraf3 = false;

  public verGraf2 = false;
  public verGraf4 = false;
  public tipo = 'radar';
  public tipo2 = 'line';

  public color = ['#76C4D5'];
  public colorMulti: any = ['#2843A0', '#15A075', '#36CAE8', '#78EAD2', '#F88476', '#E23E6A'];

  private numEvaluaciones = 1;
  /*Filtros*/
  public cadenaEvaluacion = [];
  public Periodos = [];
  /*Titulos y subtitulos*/
  public subTitles = '';
  public fechaG = '';
  /*Entidades*/
  private evaluacionEntity = new EvaluacionEntity;
  private idAdmin: string;
  /*Datos*/
  public dataOrdenado = [];
  public dataAll = [];
  public verTabla = false;
  public dataAllPromedio = [];
  public dataIndicadorfal = [];
  public indicadorCRL = [];
  public indicadores = [];
  /*Datos graficas*/
  public dataGrafica1 = [];
  public dataGrafica2 = [];
  /* indicadores a mostrar */
  private mostrar;
  public graf1 = false;
  public graf2 = false;

  public suffix = 'Gs';
  public miles = ',';
  public decimal = '.';
  public modalOpen: boolean = false;
  constructor(
    public dataService: DataService,
    private cookieService: CookieService,
    private translate: TranslateService,
    private exportExcel: ExcelService,
    private service: IndicadoresCoberturaService,
    private serviceRCL: ServiciosRiegosService
  ) {
    if (this.cookieService.get('reload') === 'true') {
      this.cookieService.set('reload', 'false', { path: '/' })
      location.reload();
    }
    this.evaluacionEntity = new EvaluacionEntity;
    this.evaluacionEntity.Id_Plantilla = Number(cookieService.get('idPlanFin'));
    this.evaluacionEntity.Id_Institucion = Number(cookieService.get('idInstitucion'));
    this.idAdmin = companiesFinanciero.find(c => Number(c.id) === this.evaluacionEntity.Id_Institucion)?.idAdmin ?? '';
  }

  async ngOnInit(): Promise<void> {
    await this.getEvaluacion();
  }

  /*Consultas*/
  private async getEvaluacion() {
    try {
      const data = await this.service.getEvaluaciones(this.evaluacionEntity.Id_Plantilla);
      await this.ordenamientoDataEvaluacion([].concat(data.evaluaciones));
    } catch (err) {
      messages.errorMessageGraph(err);
    }
  }
  private async getDetalleEvaluacion() {
    try {
      const promises = this.cadenaEvaluacion.map(eva =>
        this.service.getDetalleIndicadores(eva.idEvaluacion)
      );
      const results = await Promise.all(promises);
      let datos = [];
      results.forEach((data, index) => {
        const eva = this.cadenaEvaluacion[index];
        var aux = [];
        for (const d of data.detalleEvaluacionIndicadors) {
          aux.push({
            eval: eva.evaluacion,
            ...d
          });
        }
        datos = datos.concat(aux);
      });
      this.getIndicadores(datos);
    } catch (err) {
      messages.errorMessageGraph(err);
    }
  }
  private async getIndicadores(array) {
    try {
      const data = await this.service.getIndicadores(this.evaluacionEntity.Id_Plantilla);
      let datos = data.indicadores;
      this.mostrar = indCoberturas.mostrarInd(this.evaluacionEntity.Id_Plantilla);
      if (datos) {
        let aux = [];
        for (const dat of array) {
          if(this.mostrar.length === 0){
            var nombre = companiesFinanciero.find(c => Number(c.id) === Number(this.cookieService.get('idInstitucion'))).name;
            messages.infoMessageGraph(nombre + this.translate.instant('swal.instNoInfo'));
            break;
          }
          if (this.mostrar.includes(dat.idIndicador)) {
            const ind = datos.filter(ele => ele.id === dat.idIndicador)
            aux.push({
              "idEvaluacion": dat.idEvaluacion,
              "idIndicador": dat.idIndicador,
              "valor": dat.valor,
              "textoSemaforo": dat.textoSemaforo,
              "descripcion": ind[0].descripcion,
              "nivel": ind[0].nivel - 1,
              "alcance": indCoberturas.obtenerPuntos(this.evaluacionEntity.Id_Plantilla, dat.idIndicador, dat.valor),
              "eval": dat.eval,
              "peso": indCoberturas.obtenerPeso(this.evaluacionEntity.Id_Plantilla, dat.idIndicador) * indCoberturas.obtenerPuntos(this.evaluacionEntity.Id_Plantilla, dat.idIndicador, dat.valor) / 100,
            });
          }
        }
        this.indicadores = aux;
        this.dataAllPromedio = [];
        this.dataIndicadorfal = [];
        this.indicadorCRL = [];
        this.evaluacionEntity.Id_Plantilla === 7 ? await this.getDataPromedios(this.cadenaEvaluacion[0].idEvaluacion) : await this.getDataRiesgos(this.cadenaEvaluacion[0].idEvaluacion);
      }
    } catch (err) {
      messages.errorMessageGraph(err);
    }
  }
  private async getDataRiesgos(eva){
    // this.dataGraf = [];
    // this.datos['data'] = [];
    // this.evaluaciones = [];
    var periodoSelec;
    this.Periodos.forEach( e => {
      const ex = e.series.find(m => m.id === eva);
      if(ex){
        periodoSelec = ex;
      }
    });
    try{
      const rcl = await this.serviceRCL.getRCL(this.idAdmin, periodoSelec.nmes, periodoSelec.an);
      if(rcl.length !== 0){
        const rclF = rcl.map(e =>{
          return {
            id: e.name,
            ...e
          }
        })
        const cuentasAT = cobertura.cuentasAT(this.evaluacionEntity.Id_Plantilla);
        await this.agregarACuentasTotal(
          cuentasAT['cuentas'],
          eva,
          this.serviceRCL.getDetalleCuenta.bind(this.service),
          'detalleEvaluacionCuenta',
          'idCuenta',
          rclF
        );

        await this.agregarACuentasTotal(
          cuentasAT['varTemp'],
          eva,
          this.serviceRCL.getDetalleVarTemp.bind(this.service),
          'detalleEvaluacionVarTemp',
          'idVarTemp',
          rclF
        );

        await this.agregarACuentasTotal(
          cuentasAT['var'],
          eva,
          this.serviceRCL.getVariable.bind(this.service),
          'detalleEvaluacionVariable',
          'idVariable',
          rclF
        );
        if(this.dataIndicadorfal.length === 0){
          // this.getDataTabla(rclF);
          this.dataIndicadorfal.push({
            data: rclF,
            eva: eva
          });
          if(this.dataIndicadorfal.length === this.cadenaEvaluacion.length){
            this.iterarDatosGraf();
          }else{
            for(const data of  this.cadenaEvaluacion){
              const existe = this.dataIndicadorfal.filter(ev => ev.eva === data.idEvaluacion);
              if(existe.length===0){
                this.getDataRiesgos(data.idEvaluacion);
                break;
              }
            }
          }
        }else{
          this.dataIndicadorfal.push({
            data: rclF,
            eva: eva
          });
          if(this.dataIndicadorfal.length === this.cadenaEvaluacion.length){
            this.iterarDatosGraf();
          }else{
            for(const data of  this.cadenaEvaluacion){
              const existe = this.dataIndicadorfal.filter(ev => ev.eva === data.idEvaluacion);
              if(existe.length===0){
                this.getDataRiesgos(data.idEvaluacion);
                break;
              }
            }
          }
        }
      }
    }catch(err){}
  }
  private async agregarACuentasTotal<T>(cuentas: string[],idEvaluacion: number,servicio: (idEval: number, id: string) => Promise<any>,
    detalleKey: string, idKey: string, cuentasTotal:any[]) {
    const promesas = cuentas.map(id =>
      servicio(idEvaluacion, id)
    );
    const resultados = await Promise.all(promesas);
    resultados.forEach(r => {
      const detalle = r?.[detalleKey];
      if (!detalle) return;
      const idCuenta = detalle[idKey];
      cuentasTotal.push({
        id: detalle[idKey],
        name: detalle[idKey],
        valor: detalle.valor,
        anio: this.cadenaEvaluacion.find(i => i.idEvaluacion === idEvaluacion).an,
        mes: this.cadenaEvaluacion.find(i => i.idEvaluacion === idEvaluacion).mesNum
      });
    });
  }
  private async getDataPromedios(eva) {
    var val = [], periodos = 0;
    for (var an = this.Periodos.length - 1; an >= 0; an--) {
      for (var mes = this.Periodos[an].series.length - 1; mes >= 0; mes--) {
        if (this.Periodos[an].series[mes].id === eva && periodos === 0) {
          val.push(this.Periodos[an].series[mes]);
          periodos++;
        } else if (periodos < 3 && periodos !== 0) {
          val.push(this.Periodos[an].series[mes]);
          periodos++;
        }
      }
    }
    await this.getPromQueryCuentas(val, eva);
  }
  private async getPromQueryCuentas(arreglo, eva) {
    var variables;
    let datos = [];
    const cuentas: any = indCoberturas.cuentasIndCobertura(this.evaluacionEntity.Id_Plantilla)['cuentasp'];
    const promises = cuentas.map(val => {
      switch (arreglo.length) {
        case 1:
          variables = {
            idEvaluacion1: arreglo[0].id,
            idEvaluacion2: arreglo[0].id,
            idEvaluacion3: arreglo[0].id,
            idCuenta: val,
          }
          break;
        case 2:
          variables = {
            idEvaluacion1: arreglo[0].id,
            idEvaluacion2: arreglo[1].id,
            idEvaluacion3: arreglo[0].id,
            idCuenta: val,
          }
          break;
        case 3:
          variables = {
            idEvaluacion1: arreglo[0].id,
            idEvaluacion2: arreglo[1].id,
            idEvaluacion3: arreglo[2].id,
            idCuenta: val,
          }
          break;
      }
      return this.service.getCuentasProm(variables);
    });
    try {
      const results = await Promise.all(promises);
      results.forEach((data) => {
        var pro = [];
        switch (arreglo.length) {
          case 1:
            pro = [data.val1.valor];
            break;
          case 2:
            pro = [data.val1.valor, data.val2.valor];
            break;
          case 3:
            pro = [data.val1.valor, data.val2.valor, data.val3.valor];
            break;
        }
        datos.push({
          id: data.val1.idCuenta,
          valor: pro,
          idEvaluacion: data.val1.idEvaluacion,
          descripcion: '',
        });
      });
      await this.getPromQueryVarTemp(arreglo, datos, eva);
    } catch (err) {
      messages.errorMessageGraph(err);
    }
  }
  private async getPromQueryVarTemp(arreglo, datos, eva) {
    var variables;
    const cuentas: any = indCoberturas.cuentasIndCobertura(this.evaluacionEntity.Id_Plantilla)['varTempp'];
    const promises = cuentas.map(val => {
      switch (arreglo.length) {
        case 1:
          variables = {
            idEvaluacion1: arreglo[0].id,
            idEvaluacion2: arreglo[0].id,
            idEvaluacion3: arreglo[0].id,
            idVarTemp: val,
          }
          break;
        case 2:
          variables = {
            idEvaluacion1: arreglo[0].id,
            idEvaluacion2: arreglo[1].id,
            idEvaluacion3: arreglo[0].id,
            idVarTemp: val,
          }
          break;
        case 3:
          variables = {
            idEvaluacion1: arreglo[0].id,
            idEvaluacion2: arreglo[1].id,
            idEvaluacion3: arreglo[2].id,
            idVarTemp: val,
          }
          break;
      }
      return this.service.getVarTempProm(variables);
    });
    try {
      const results = await Promise.all(promises);
      results.forEach((data) => {
        var pro = [];
        switch (arreglo.length) {
          case 1:
            pro = [data.val1.valor];
            break;
          case 2:
            pro = [data.val1.valor, data.val2.valor];
            break;
          case 3:
            pro = [data.val1.valor, data.val2.valor, data.val3.valor];
            break;
        }
        datos.push({
          id: data.val1.idVarTemp,
          valor: pro,
          idEvaluacion: data.val1.idEvaluacion,
          descripcion: '',
        });
      });
      await this.getPromQueryVar(arreglo, datos, eva)
    } catch (err) {
      messages.errorMessageGraph(err);
    }
  }
  private async getPromQueryVar(arreglo, datos, eva) {
    var variables;
    const cuentas: any = indCoberturas.cuentasIndCobertura(this.evaluacionEntity.Id_Plantilla)['variablesp'];
    const promises = cuentas.map(val => {
      switch (arreglo.length) {
        case 1:
          variables = {
            idEvaluacion1: arreglo[0].id,
            idEvaluacion2: arreglo[0].id,
            idEvaluacion3: arreglo[0].id,
            idVariable: val,
          }
          break;
        case 2:
          variables = {
            idEvaluacion1: arreglo[0].id,
            idEvaluacion2: arreglo[1].id,
            idEvaluacion3: arreglo[0].id,
            idVariable: val,
          }
          break;
        case 3:
          variables = {
            idEvaluacion1: arreglo[0].id,
            idEvaluacion2: arreglo[1].id,
            idEvaluacion3: arreglo[2].id,
            idVariable: val,
          }
          break;
      }
      return this.service.getVarProm(variables);
    });
    try {
      const results = await Promise.all(promises);
      results.forEach((data) => {
        var pro = [];
        switch (arreglo.length) {
          case 1:
            pro = [data.val1.valor];
            break;
          case 2:
            pro = [data.val1.valor, data.val2.valor];
            break;
          case 3:
            pro = [data.val1.valor, data.val2.valor, data.val3.valor];
            break;
        }
        datos.push({
          id: data.val1.idVariable,
          valor: pro,
          idEvaluacion: data.val1.idEvaluacion,
          descripcion: '',
        });
      });
      this.dataAllPromedio.push({
        data: datos,
        eva: eva
      });
      await this.getInversiones(eva);
    } catch (err) {
      messages.errorMessageGraph(err);
    }
  }
  private async getInversiones(eva) {
    var datos = [];
    let sel = this.cadenaEvaluacion.filter(per => per.idEvaluacion === eva)[0];
    const per = sel.an + '-' + FuncionesMes.f_switchmes3(sel.mes) + '-01';
    try {
      const data = await this.service.getInversiones(per);
      datos.push({
        id: 'INV1',
        valor: data.inversiones_sub_calculos['INV_01'].de_1_7 + data.inversiones_sub_calculos['INV_01'].de_8_15 + data.inversiones_sub_calculos['INV_01'].de_16_30,
        idEvaluacion: eva,
      });
      await this.getAsientos(datos, eva);
    } catch (err) {
      messages.errorMessageGraph(err);
    }
  }
  private async getAsientos(datos, eva) {
    let sel = this.cadenaEvaluacion.filter(per => per.idEvaluacion === eva)[0];
    const per = sel.an + '-' + FuncionesMes.f_switchmes3(sel.mes) + '-01';
    try {
      const data = await this.service.getAsientos(per);
      datos.push({
        id: 'ASI1',
        valor: data.creditos_sub_calculos['ASI_01'].de_1_7 + data.creditos_sub_calculos['ASI_01'].de_8_15 + data.creditos_sub_calculos['ASI_01'].de_16_30,
        idEvaluacion: eva,
      });
      datos.push({
        id: 'ASI2',
        valor: data.creditos_sub_calculos['ASI_02'].de_1_7 + data.creditos_sub_calculos['ASI_02'].de_8_15 + data.creditos_sub_calculos['ASI_02'].de_16_30,
        idEvaluacion: eva,
      });
      await this.getDataLiquidez(datos, eva);
    } catch (err) {
      messages.errorMessageGraph(err);
    }
  }
  private async getDataLiquidez(datos, eva, graf?) {
    let sel = this.cadenaEvaluacion.filter(per => per.idEvaluacion === eva)[0];
    const per = sel.an + '-' + FuncionesMes.f_switchmes3(sel.mes) + '-01';
    const data = await this.service.getLiquidez(per);
    const dat = data.liquidaciones_sub_calculos;
    datos.push({
      id: 'LIQ_01',
      valor: dat.LIQ_01.de_1_7 + dat.LIQ_01.de_8_15 + dat.LIQ_01.de_16_30,
      idEvaluacion: eva,
    });
    datos.push({
      id: 'LIQ_02',
      valor: dat.LIQ_02.de_1_7 + dat.LIQ_02.de_8_15 + dat.LIQ_02.de_16_30,
      idEvaluacion: eva,
    });
    await this.getDataAhorros(datos, eva, graf);
  }
  private async getDataAhorros(datos, eva, graf?) {
    let sel = this.cadenaEvaluacion.filter(per => per.idEvaluacion === eva)[0];
    const per = sel.an + '-' + FuncionesMes.f_switchmes3(sel.mes) + '-01';
    const data = await this.service.getAhorros(per);
    const dat = data.ahorros_sub_calculos;

    datos.push({
      id: 'AHO_02',
      valor: dat.AHO_02.de_1_7 + dat.AHO_02.de_8_15 + dat.AHO_02.de_16_30,
      idEvaluacion: eva,
    });
    datos.push({
      id: 'AHO_03',
      valor: dat.AHO_03 / 30 * 7 + dat.AHO_03 / 30 * 8 + dat.AHO_03 / 30 * 15,
      idEvaluacion: eva,
    });
    datos.push({
      id: 'AHO_04',
      valor: dat.AHO_04 / 30 * 7 + dat.AHO_04 / 30 * 8 + dat.AHO_04 / 30 * 15,
      idEvaluacion: eva,
    });
    datos.push({
      id: 'AHO_05',
      valor: dat.AHO_05 / 30 * 7 + dat.AHO_05 / 30 * 8 + dat.AHO_05 / 30 * 15,
      idEvaluacion: eva,
    });
    await this.getDataCuentas(datos, eva);
  }
  private async getDataCuentas(datos, eva) {
    const promises = cuenta.map(val =>
      this.service.getDetalleCuenta(eva, val)
    );
    try {
      const results = await Promise.all(promises);
      results.forEach((data) => {
        datos.push({
          id: data.detalleEvaluacionCuenta.idCuenta,
          valor: data.detalleEvaluacionCuenta.valor,
          idEvaluacion: data.detalleEvaluacionCuenta.idEvaluacion,
        });
      });
      await this.getVariables(datos, eva);
    } catch (err) {
      messages.errorMessageGraph(err);
    }
  }
  private async getVariables(datos, eva) {
    const promises = variable.map(val =>
      this.service.getVariable(eva, val)
    );
    try {
      const results = await Promise.all(promises);
      results.forEach((data) => {
        datos.push({
          id: data.detalleEvaluacionVariable.idVariable,
          valor: data.detalleEvaluacionVariable.valor,
          idEvaluacion: data.detalleEvaluacionVariable.idEvaluacion,
        });
      });
      await this.getVariablesTemp(datos, eva);
    } catch (err) {
      messages.errorMessageGraph(err);
    }
  }
  private async getVariablesTemp(datos, eva) {
    const promises = variableTemp.map(val =>
      this.service.getVarTemp(eva, val)
    );
    try {
      const results = await Promise.all(promises);
      results.forEach((data) => {
        datos.push({
          id: data.detalleEvaluacionVarTemp.idVarTemp,
          valor: data.detalleEvaluacionVarTemp.valor,
          idEvaluacion: data.detalleEvaluacionVarTemp.idEvaluacion,
        });
      });
      this.dataIndicadorfal.push({
        data: datos,
        eva: eva
      });
      if (this.dataIndicadorfal.length === this.cadenaEvaluacion.length) {
        this.iterarDatosGraf();
      } else {
        for (const data of this.cadenaEvaluacion) {
          const existe = this.dataIndicadorfal.filter(ev => ev.eva === data.idEvaluacion);
          if (existe.length === 0) {
            await this.getDataPromedios(data.idEvaluacion);
            break;
          }
        }
      }
    } catch (err) {
      messages.errorMessageGraph(err);
    }
  }
  private iterarDatosGraf() {
    for (const dat of this.dataIndicadorfal) {
      this.getDataTablaVal(dat.data, dat.eva);
    }
  }
  private getDataTablaVal(data, eva) {
    this.dataAll = data;
    var dataTabla = [], aux = [];
    for (var i = 1; ; i++) {
      const dat = cobertura.tabla(this.evaluacionEntity.Id_Plantilla,i);
      if (dat === undefined) {
        break;
      } else {
        let dta = dat[0], value = 0;
        if (dta.codigo !== 'suma' && dta.codigo !== 'encabezado' && dta.codigo !== 'subtot') {
          if (dta.codigo !== '') {
            if (dta.prom) {
              value = this.getPromedio(dta, eva);
            } else {
              value = calculos.calculos(dta.codigo, data);
              if (dta.gap) {
                value = value / 8 * 3;
              }
            }
          }
          aux.push({
            concepto: dta.concepto,
            factor: dta.factor,
            saldo: value,
            admisible: (value * dta.factor) / 100,
            codigo: dta.codigo
          });
        } else if (dta.codigo === 'encabezado') {
          aux.push({
            concepto: dta.concepto,
            factor: 0,
            saldo: 0,
            admisible: 0,
            codigo: dta.codigo
          });
        } else if (dta.codigo === 'subtot') {
          let s = 0, a = 0;
          for (const val of aux) {
            s += val.saldo;
            a += val.admisible;
          }
          aux.push({
            concepto: dta.concepto,
            factor: '',
            saldo: s,
            admisible: a,
            codigo: dta.codigo
          });
        } else {
          let s = 0, a = 0;
          for (const val of aux) {
            if (val.codigo !== 'subtot' && dta.codigo !== 'encabezado') {
              s += val.saldo;
              a += val.admisible;
            }
          }
          aux.push({
            concepto: dta.concepto,
            factor: '',
            saldo: s,
            admisible: a,
            codigo: dta.codigo
          });
          dataTabla.push(aux);
          aux = [];
        }
      }
    }
    this.getDataTabFinalVal(dataTabla, eva);
  }
  private getDataTabFinalVal(dataTabla, eva) {
    var aux = [];
    aux.push({
      concepto: 'Activos líquidos de alta calidad',
      factor: '',
      saldo: dataTabla[0][dataTabla[0].length - 1].admisible,
      admisible: 'Estrés',
      codigo: 't',
      rowspan: 1
    });
    aux.push({
      concepto: 'Salidas de efectivo totales',
      factor: '',
      saldo: dataTabla[1][dataTabla[1].length - 1].admisible,
      admisible: 'Máx. nivel de entradas / salidas',
      codigo: 't',
      rowspan: 2
    });
    aux.push({
      concepto: 'Entradas de efectivo totales',
      factor: '',
      saldo: dataTabla[2][dataTabla[2].length - 1].admisible,
      admisible: 'Máx. nivel de entradas / salidas',
      codigo: 't',
      rowspan: 0
    });
    var por = 0;
    if (dataTabla[1][dataTabla[1].length - 1].admisible !== 0) {
      por = Number((dataTabla[2][dataTabla[2].length - 1].admisible / dataTabla[1][dataTabla[1].length - 1].admisible * 100).toFixed(2));
    }
    aux.push({
      concepto: 'Entradas de efectivo ajustadas',
      factor: '',
      saldo: por,
      admisible: 50,
      codigo: 'e',
      rowspan: 1
    });
    let text = '0';
    if (dataTabla[1][dataTabla[1].length - 1].admisible !== 0) {
      if (por <= 75) {
        text = 'Sin ajuste';
      } else {
        text = (dataTabla[1][dataTabla[1].length - 1].admisible * 75 / 100).toFixed(0)
      }
    }
    let por2 = 0;
    if (dataTabla[1][dataTabla[1].length - 1].admisible !== 0) {
      por2 = dataTabla[1][dataTabla[1].length - 1].admisible * 50 / 100;
    }

    aux.push({
      concepto: 'Entradas de efectivo ajustadas',
      factor: 75,
      saldo: text,
      admisible: por2,
      codigo: 'r',
      rowspan: 1
    });
    let text2 = 0;
    if (dataTabla[1][dataTabla[1].length - 1].admisible !== 0) {
      if (por < 75) {
        text2 = Number(((dataTabla[0][dataTabla[0].length - 1].admisible
          + dataTabla[2][dataTabla[2].length - 1].admisible)
          / dataTabla[1][dataTabla[1].length - 1].admisible * 100).toFixed(0))
      } else {
        if (text === 'Sin ajuste') {
          text2 = Number(((dataTabla[0][dataTabla[0].length - 1].admisible) / dataTabla[1][dataTabla[1].length - 1].admisible * 100).toFixed(2));
        } else {
          text2 = Number(((dataTabla[0][dataTabla[0].length - 1].admisible + Number(text)) / dataTabla[1][dataTabla[1].length - 1].admisible * 100).toFixed(2))
        }
      }
    }
    let por3 = 0;
    if (dataTabla[1][dataTabla[1].length - 1].admisible !== 0 && por2 !== 0) {
      por3 = Number(((dataTabla[0][dataTabla[0].length - 1].admisible
        + por2)
        / dataTabla[1][dataTabla[1].length - 1].admisible * 100).toFixed(0))
    }
    aux.push({
      concepto: 'Entradas de efectivo ajustadas',
      factor: '',
      saldo: text2,
      admisible: por3,
      codigo: 'p',
      rowspan: 1
    });
    this.indicadorCRL.push({
      valor: text2,
      eva: eva
    })
    if (this.indicadorCRL.length === this.cadenaEvaluacion.length) {
      this.obtDataOrdenado(this.indicadores);
    }
  }
  private getPromedio(esp, eva) {
    var val = 0
    const valores = this.dataAllPromedio.filter(dat => dat.eva === eva)[0].data
    if (valores) {
      for (var i = 0; i < valores[0].valor.length; i++) {
        val += calculos.calculosProm(esp.codigo, valores, i)
      }
      let p = val / valores[0].valor.length;
      val = (p * 7 / 30) + (p * 8 / 30) + (p * 15 / 30);
      return val;
    }
    return 0;
  }

  private ordenamientoId(array) {
    array.sort(function (a: any, b: any) {
      if (moment(FuncionesMes.escrituraPer(a.eva)).isBefore(moment(FuncionesMes.escrituraPer(b.eva)))) {
        return 1;
      }
      if (moment(FuncionesMes.escrituraPer(a.eva)).isAfter(moment(FuncionesMes.escrituraPer(b.eva)))) {
        return -1;
      }
      return 0;
    });
    return array;
  }

  /* Obtención de periodos */
  private async obtenerDataEvaluacion() {
    this.cadenaEvaluacion = [];
    this.subTitles = "";
    var tot = 0;
    for (var i = this.Periodos.length - 1; i >= 0; i--) {
      if (this.Periodos[i].visible) {
        for (var j = this.Periodos[i].series.length - 1; j >= 0; j--) {
          if (this.Periodos[i].series[j].check || (tot > 0 && tot < 12)) {
            this.cadenaEvaluacion.push({
              evaluacion: this.Periodos[i].series[j].periodo,
              idEvaluacion: this.Periodos[i].series[j].id,
              porcentaje: '%',
              pos: this.Periodos[i].series[j].pos,
              an: this.Periodos[i].series[j].an,
              mes: this.Periodos[i].series[j].mes
            });
            tot++;
          }
        }
      }

    }
    this.subTitles = this.cadenaEvaluacion[0].evaluacion;
    await this.getDetalleEvaluacion();
  }

  /*Obtención de datos*/
  private async ordenamientoDataEvaluacion(datos) {
    const info = CommonVariables.obtenerPeriodos(datos, this.numEvaluaciones);
    this.Periodos = info.periodos;
    for (const an of this.Periodos) {
      if (an.anio < 2023) {
        an.visible = false;
      }
    }
    await this.obtenerDataEvaluacion();
  }
  private async obtDataOrdenado(data) {
    this.dataAll = await this.genFiltroIndicadoresNivel(data, 0, 1);
    this.ingresarIndicadorNuevo();
    this.dataAll = this.ordenamientoId(this.dataAll);
    this.dataOrdenado = [];
    for (const dat of this.dataAll) {
      let sum = 0;
      dat.series.forEach(ind => sum += ind.peso);
      dat.calificacion = sum;
      if (dat.idEvaluacion === this.cadenaEvaluacion[0].idEvaluacion) {
        this.dataOrdenado.push(dat);
      }
    }
    this.verTabla = true;
    this.obtenerDataGraf();
  }
  private genFiltroIndicadoresNivel(array, pos, nivel, indicador?) {
    var aux = [];
    for (var i = pos; i < array.length; i++) {
      if (array[i].nivel === nivel) {
        let pos = this.cadenaEvaluacion.filter(dat => dat.idEvaluacion === array[i].idEvaluacion)
        aux.push({
          "idEvaluacion": array[i].idEvaluacion,
          "idIndicador": array[i].idIndicador,
          "valor": array[i].valor,
          "textoSemaforo": array[i].textoSemaforo,
          "descripcion": array[i].descripcion,
          "nivel": array[i].nivel,
          "alcance": array[i].alcance,
          "peso": array[i].peso,
          "calificacion": 0,
          "pos": pos[0].pos,
          "eva": array[i].eval,
          "series": this.genFiltroIndicadoresNivel(array, i + 1, nivel + 1, array[i])
        });
      } else if (array[i].nivel < nivel) {
        break;
      }
    }
    return aux;
  }
  private ingresarIndicadorNuevo(){
    var ind = indCoberturas.mostrarInd(this.evaluacionEntity.Id_Plantilla);
    var nameind = ind[ind.length-1];
    for(const val of this.dataAll){
      const d = this.indicadorCRL.filter(i => i.eva === val.idEvaluacion);
      val.series.push({
        "idEvaluacion": val.idEvaluacion,
        "idIndicador": nameind,
        "valor": d[0].valor,
        "textoSemaforo": "",
        "descripcion": "Ratio de cobertura de liquidez",
        "nivel": 2,
        "alcance": indCoberturas.obtenerPuntos(this.evaluacionEntity.Id_Plantilla ,nameind, d[0].valor),
        "peso": indCoberturas.obtenerPeso(this.evaluacionEntity.Id_Plantilla, nameind)*indCoberturas.obtenerPuntos(this.evaluacionEntity.Id_Plantilla, nameind, d[0].valor)/100,
        "calificacion": 0,
        "pos": undefined,
        "series": []
      })     
    }
  }
  public getCalificacion() {
    const punt = this.dataOrdenado[0].calificacion;
    if (punt >= 0 && punt < 50) {
      return 'E'
    } else if (punt >= 50 && punt < 60) {
      return 'D'
    } else if (punt >= 60 && punt < 70) {
      return 'C'
    } else if (punt >= 70 && punt < 80) {
      return 'B'
    } else if (punt >= 80 && punt < 90) {
      return 'BB'
    } else if (punt >= 90 && punt < 95) {
      return 'A'
    } else if (punt >= 95 && punt <= 100) {
      return 'AA'
    }
    return '';
  }
  getCalificacionFormato(): string {
    if (this.dataOrdenado.length === 0) return '';
    const numero = this.dataOrdenado[0].calificacion;
    const letra = this.getCalificacion();
    return `${numero} | ${letra}`;
  }

  getColorCalificacion(): string {
    const cal = this.getCalificacion();
    if (cal === 'A' || cal === 'AA') return '#4CAF50'; // verde
    if (cal === 'B' || cal === 'BB') return '#FFC107'; // amarillo
    if (cal === 'C' || cal === 'D') return '#FF9800';  // naranja
    if (cal === 'E') return '#F44336';                  // rojo
    return '#1976d2';
  }

  private obtenerDataGraf() {
    let aux = []
    for (const dat of this.dataOrdenado[0].series) {
      aux.push({
        name: dat.idIndicador,
        value: dat.alcance
      });
    }
    this.dataGrafica1 = [];
    this.dataGrafica1.push({
      name: "indicadores",
      series: aux
    });
    this.opcionesGrafica1(this.tipo);
    aux = [];
    for (const dat of this.dataAll) {
      let data = this.cadenaEvaluacion.filter(eva => eva.idEvaluacion === dat.idEvaluacion)
      aux.push({
        name: data[0].evaluacion,
        value: dat.calificacion
      });
    }
    this.dataGrafica2 = [];
    this.dataGrafica2.push({
      name: "Calificación",
      series: aux
    });
    this.opcionesGrafica2(this.tipo2);
  }
  public opcionesGrafica1(tipo?) {
    this.tipo = tipo;
    if (!this.verGraf) {
      tipo = 'radar'
    } else if (tipo === undefined) {
      tipo = this.tipo;
    }

    this.tipoGraf1Actual = tipo;

    // Preparar datos para graficador
    let data = [], categories = [];
    for (const dat of this.dataGrafica1) {
      let values = [];
      for (const val of dat.series) {
        values.push(val.value)
        categories.push(val.name)
      }
      data.push({
        name: dat.name,
        data: values,
      })
    }

    // Guardar para usar en el template
    this.dataGraf1FormattedForGraficador = data;
    this.labelsGraf1 = categories;

    this.verGraf = true;
  }
  public opcionesGrafica2(tipo?) {
    this.tipo2 = tipo;
    if (!this.verGraf2) {
      tipo = 'line'
    } else if (tipo === undefined) {
      tipo = this.tipo2;
    }

    this.tipoGraf2Actual = tipo;

    // Preparar datos para graficador
    let data = [], categories = [];
    for (const dat of this.dataGrafica2) {
      let values = [];
      for (const val of dat.series.reverse()) {
        values.push(val.value)
        categories.push(val.name)
      }
      data.push({
        name: dat.name,
        data: values,
      })
    }

    // Guardar para usar en el template
    this.dataGraf2FormattedForGraficador = data;
    this.labelsGraf2 = categories;
    this.fechaG = categories[0] + " - " + categories[categories.length - 1];

    this.verGraf2 = true;
  }
  /*Filtros*/
  public cambioPeriodo(per) {
    for (const an of this.Periodos) {
      for (const mes of an.series) {
        if (mes.periodo === per.periodo) {
          mes.check = true;
        } else {
          mes.check = false;
        }
      }
    }
    this.obtenerDataEvaluacion();
  }
  /* acciones en filtros */
  public numPerSelect() {
    var selecc = 0;
    for (const an of this.Periodos) {
      for (const mes of an.series) {
        if (mes.check) {
          selecc++;
        }
      }
    }
    if (selecc > 1)
      return true;
    return false;
  }
  /* formateo de datos */
  public escrituraPer(Periodo) {
    if (Periodo.split(' ').length === 2) {
      const datos = Periodo.split(' ');
      return this.translate.instant('filtros.' + datos[0]) + ' ' + datos[1];
    } else if (Periodo.split(' ').length === 5) {
      const datos = Periodo.split(' ');
      return this.translate.instant('filtros.' + datos[0]) + ' ' + datos[1] + ' ' + datos[2] + ' ' + this.translate.instant('filtros.' + datos[0]) + ' ' + datos[1];
    }
    return Periodo;
  }
  /* Modales */
  public openModal(modal) {

    this.graf1 = false;
    this.graf2 = false;
    switch (modal) {
      case 'graf1':
        this.graf1 = true;
        this.verGraf3 = true;
        break;
      case 'graf2':
        this.graf2 = true;
        this.verGraf4 = true;
        break;
    }
    this.modalOpen = true;
  }
  public exportarExcel() {
    var titulos = [], encabezados = [], datos = [];

    titulos.push(this.translate.instant('financiero.evaluacionIndicador.titulo1Tabla'));
    titulos.push(this.translate.instant('financiero.evaluacionIndicador.titulo2Tabla'));
    titulos.push(this.translate.instant('financiero.evaluacionIndicador.titulo3Tabla'));
    titulos.push(this.translate.instant('financiero.evaluacionIndicador.titulo4Tabla'));

    encabezados.push(this.dataOrdenado[0].idIndicador);
    encabezados.push(this.dataOrdenado[0].descripcion);
    encabezados.push("");
    encabezados.push("");

    for (let i = 0; i < this.dataOrdenado[0].series.length; i++) {
      var aux = [];
      aux.push(this.dataOrdenado[0].series[i].idIndicador);
      aux.push(this.dataOrdenado[0].series[i].descripcion);
      aux.push(this.dataOrdenado[0].series[i].valor);
      aux.push(this.dataOrdenado[0].series[i].alcance);

      datos.push(aux);
    }
    let tituloHoja = this.translate.instant('credito.concentracion.tituloTabla') + " | " + this.escrituraPer(this.subTitles)
    this.exportExcel.excelFinancieroIndCobertura(tituloHoja, titulos, encabezados, datos, 'Evaluación ' + this.escrituraPer(this.subTitles));
  }
  //exportar grafica en imagen 
  public exportarGraficaSup(id, nombre) {
    // IMG.exportimagenes(id, nombre + " " + this.escrituraPer(this.subTitles));
    var name = { 
      titulo: this.translate.instant('menu.'+this.dataService.subModuleSelect),
      subtitulo: nombre + " " + this.escrituraPer(this.subTitles),
      nombreArch: this.translate.instant('menu.'+this.dataService.subModuleSelect)
    }
    
    const comp = this.grafCmp.find(g => g.zona === id);
    comp.exportImg(id,name);
  }
  //exportar grafica en imagen 
  public exportarGraficaInf(id, nombre) {
    let f = this.escrituraPer(this.subTitles);
     var name = { 
      titulo: this.translate.instant('menu.'+this.dataService.subModuleSelect),
      subtitulo: this.translate.instant(nombre) + " " + f,
      nombreArch: this.translate.instant('menu.'+this.dataService.subModuleSelect)
    }
    
    const comp = this.grafCmp.find(g => g.zona === id);
    comp.exportImg(id,name);
  }
}
